import { QueryHookOptions, useQuery } from '@apollo/client';
import query from '../../queries/vehicleOptions';

export interface VehicleOption {
  id: number;
  price: number;
  currency: string;
  active: boolean;
  isHidden: boolean;
  vehicleOptionType: {
    id: number;
    categoryCode: string;
    categoryName: string;
    typeCode: string;
    typeName: string;
  };
  combinations: {
    vehicleOptionId: number;
    vehicleOptionTypeId: number;
    vehicleOptionTypeCategoryCode: string;
  }[];
  createdBy: string;
}

interface UseVehicleOptionsResponse {
  vehicleOptions: VehicleOption[];
}

interface UseVehicleOptionsRequest {
  modelId: number;
}

export default function useVehicleOptions(modelId: number, options: QueryHookOptions<UseVehicleOptionsResponse, UseVehicleOptionsRequest> = {}) {
  const { data, ...rest } = useQuery<UseVehicleOptionsResponse, UseVehicleOptionsRequest>(query, {
    ...options,
    variables: {
      modelId
    },
  });

  const vehicleOptions = data?.vehicleOptions;

  return {
    vehicleOptions,
    ...rest
  };
}
